import makeStyles from '@mui/styles/makeStyles';

const reallocateEmissionsStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  statusCell: {
    width: '80px',
    height: '14px',
    borderRadius: '6px',
    backgroundColor: '#abc123',
  },
  formControl: {
    margin: theme.spacing(1),
  },
}));

export default reallocateEmissionsStyles;
